import React from "react";

const Footer = () => {
  return (
    <footer className="bg-custom-blue text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <div className="flex items-center mb-4">
              <div className="w-8 h-8 mr-3 flex items-center justify-center" aria-hidden="true">
                <div className="w-6 h-6 border-2 border-white">
                  <div className="w-full h-0.5 bg-white mb-1"></div>
                  <div className="w-full h-0.5 bg-white mb-1"></div>
                  <div className="w-full h-0.5 bg-white"></div>
                </div>
              </div>
              <div>
                <p className="text-lg font-bold">
                  National Institute of BUILDING SCIENCES™
                </p>
              </div>
            </div>

            <p className="text-sky-100 mb-6">
              Innovative Solutions for the Built Environment
            </p>

            <p className="text-sm text-gray-100 mb-6">
              The Scientific Resolution Panel is managed by NIBS for the
              National Flood Insurance Program of the Federal Emergency
              Management Agency.
            </p>

            <p className="text-xs text-gray-100">
              © 2025. National Institute of Building Sciences. All Rights
              Reserved.
            </p>
            <p className="text-xs text-gray-100 mt-3">
              Powered by{" "}
              <a
                href="https://opsheaven.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sky-200 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white rounded"
              >
                OpsHeaven Technologies
              </a>
            </p>
          </div>

          <div>
            <div className="mb-4">
              <p className="text-lg font-semibold mb-2">Contact</p>
              <div className="w-12 h-0.5 bg-sky-300" aria-hidden="true"></div>
            </div>

            <div className="mb-4">
              <p className="text-sm text-gray-100">
                2121 K Street NW, Suite 800
                <br />
                Washington, DC 20037
              </p>
            </div>

            <div className="mb-6">
              <p className="text-sm text-gray-100">
                P:{" "}
                <a
                  href="tel:+12022897800"
                  className="text-white underline underline-offset-2 hover:text-sky-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white rounded"
                >
                  (202) 289-7800
                </a>
              </p>
            </div>

            <div className="flex space-x-3">
              <a
                href="https://www.facebook.com/BuildingScience"
                className="w-8 h-8 bg-blue-800 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
                aria-label="Facebook"
              >
                <span className="text-white text-sm font-bold" aria-hidden="true">
                  f
                </span>
              </a>

              <a
                href="https://x.com/BuildingScience"
                className="w-8 h-8 bg-blue-800 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
                aria-label="X (Twitter)"
              >
                <span className="text-white text-sm font-bold" aria-hidden="true">
                  X
                </span>
              </a>

              <a
                href="https://www.linkedin.com/company/national-institute-of-building-sciences"
                className="w-8 h-8 bg-blue-800 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
                aria-label="LinkedIn"
              >
                <span className="text-white text-xs font-bold" aria-hidden="true">
                  in
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
